import { put, call, takeLatest } from 'redux-saga/effects'
import lego from '../../services/lego'
import unit from '../../utils/utils'
import * as types from '../constants/index'

function getTemplateList() {
  return lego.getTemplateList().then(res => {
    let data: string[] = res.data.prefixes
    data = data.map(item => {
      return (item += 'index.html')
    })
    const templateList: string[] = unit
      .sortVersion(data)
      .reverse()
      .reduce((prev, cur) => {
        prev.push(cur.split('/')[2])
        return prev
      }, [])
    const { list, bata } = templateList.reduce(
      (init, temp) => {
        if (temp.includes('bata')) {
          init.bata.push(temp)
        } else {
          init.list.push(temp)
        }
        return init
      },
      { list: [], bata: [] } as { list: string[]; bata: string[] }
    )
    return [...list, ...bata]
  })
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function* getTemList(extroInfo) {
  try {
    const templateList = yield call(getTemplateList)
    yield put({ type: types.SET_TEMPLATELIST, templateList })
  } catch (err) {
    console.log(err)
  }
}

export default function* rootSaga() {
  yield takeLatest(types.GET_TEMPLATELIST, getTemList)
}
